import { getIdOrNull } from '..'
import apiClient from './apiClient'

export const getChatRoomMessages = (user, chatRoom) => {
  return apiClient.get(user, `api/chat-rooms/${getIdOrNull(chatRoom)}/messages`)
}

export const postMessage = (user, chatRoom, body = { content: '' }) => {
  return apiClient.post(user, `api/chat-rooms/${getIdOrNull(chatRoom)}/messages`, body)
}
